import Select, {
  components,
  DropdownIndicatorProps,
  OptionProps,
  Props,
} from 'react-select';
import { useTheme } from 'styled-components';
import { ReactNode } from 'react';

import { MergeElementProps } from '@/core/interfaces/common';
import { Check } from '@/core/components/Icons/Check';
import { ChevronDownIcon } from '@/core/components/Icons/ChevronDownIcon';

import { forwardRefWrapper } from '@/utils/forwardRefWrapper';

import {
  customSingleSelectStyles,
  OptionContainer,
} from './Select.styles';

export interface OptionType {
  label: string;
  value: string;
}

export type LabelElementProps = MergeElementProps<'label'>;

export type TitleElementProps = MergeElementProps<'div'>;

export type SelectFieldProps = Props<OptionType, false> & {
  id: string;
  labelProps?: LabelElementProps;
  titleProps?: TitleElementProps;
};
export type SelectOptionType<T = string | number | boolean | undefined> = {
  label: ReactNode;
  value: T;
  icon?: ReactNode;
};

const DropdownIndicator = (props: DropdownIndicatorProps) => {
  const { colors } = useTheme();

  return (
    <components.DropdownIndicator {...props}>
      <ChevronDownIcon
        fill={colors.black}
        {...props}
      />
    </components.DropdownIndicator>
  );
};

const Option = ({
  children,
  data,
  ...props
}: OptionProps<SelectOptionType>) => {
  const { colors } = useTheme();

  return (
    <components.Option
      {...props}
      data={data}
    >
      <OptionContainer>
        {children}
        <Check fill={colors.black} />
      </OptionContainer>
    </components.Option>
  );
};

export const SelectWrappedBase = ({
  id,
  labelProps,
  titleProps,
  name,
  ...props
}: SelectFieldProps) => (
  <Select
    id={id}
    name={name}
    styles={customSingleSelectStyles}
    components={{
      // @ts-expect-error props mismatch
      DropdownIndicator,
      // @ts-expect-error props mismatch
      Option,
    }}
    {...props}
    isMulti={false}
  />
);

export const SingleSelectDefault = forwardRefWrapper(SelectWrappedBase);
